<div id="{{this.propertyId}}FormCore"  [formGroup]="this.formGroup" *ngIf="this.formGroup" >     

    <div id="otherCoreBusinessActivities"  *ngIf="this.formGroup.get('contractOutCoreActivities') != null">
        <div class="row">
            <div class="col-md-9">
                <app-boolean-field-v2
                    label= "Does the business contract out any core business activities in B.C. that are not described in the {{this.selectCuDesc}} classification?"
                    propertyName="contractOutCoreActivities" 
                    [formGroup]="this.formGroup">
                </app-boolean-field-v2> 
            </div>
        </div>         

        <div *ngIf="this.isVehicleCu && this.formGroup.get('driveToOtherProvince') != null && 
                    (this.formGroup.value.contractOutCoreActivities === 'Y' || this.formGroup.value.contractOutCoreActivities === 'N' ) ">

            <div class="row mt-20">
                <div class="col-md-9">
                    <h2 class="subtitle">Vehicle details</h2>
                </div>
            </div>        
           
            <div class="row">
                <div class="col-md-9">
                    <app-boolean-field-v2
                        label= "Does anyone from the business drive to other provinces for work?"
                        propertyName="driveToOtherProvince" 
                        [formGroup]="this.formGroup"
                        [FIELD_SPACING]="3">
                    </app-boolean-field-v2> 
                </div>
            </div>
    
            <div class="driveToOtherProvinceVehicleDetails" *ngIf="this.formGroup.value.driveToOtherProvince === 'Y' || this.formGroup.value.driveToOtherProvince === 'N' ">
                <div class="row">
                    <div class="col-md-9">
                        <app-boolean-field-v2
                            label= "Does the business own or lease the work vehicle(s)?"                                                        
                            propertyName="vehicleOwnedOrLeased" 
                            [formGroup]="this.formGroup"
                            [values]= "[this.otherCoreBusinessActivitiesFunctions.ownVehicle, this.otherCoreBusinessActivitiesFunctions.leaseVehicle]"                                  
                            [display]="[this.otherCoreBusinessActivitiesFunctions.ownVehicle, this.otherCoreBusinessActivitiesFunctions.leaseVehicle]"     
                            (userInput)="this.updateVehicleOwnedOrLeased($event)"
                            [FIELD_SPACING]="3">
                        </app-boolean-field-v2> 
                    </div>
                </div>                       
        
                <div  *ngIf="this.formGroup.value.vehicleOwnedOrLeased === this.otherCoreBusinessActivitiesFunctions.leaseVehicle ">
                    <div class="row">       
                        <div class="col-md-9">
                            <div class="row">          
                                <div class="col-md-12">
                                    <app-text-box
                                        label="Who does the business lease the vehicles from?"
                                        propertyName="vehicleLeasingFirmName" 
                                        [formGroup]="this.formGroup"
                                        [FIELD_SPACING]="3">
                                    </app-text-box>
                                </div>     
                            </div>
                        </div>       
                    </div> 

                    <div class="row">
                        <div class="col-md-9">
                            <app-boolean-field-v2
                                label= "At the end of the lease, will the business own the vehicle(s)?"
                                propertyName="businessOwnVehicleAtEndOfLease" 
                                [formGroup]="this.formGroup"
                                [FIELD_SPACING]="3">
                            </app-boolean-field-v2> 
                        </div>
                    </div>                        
                </div>   
                
                <div  *ngIf="this.formGroup.value.vehicleOwnedOrLeased === this.otherCoreBusinessActivitiesFunctions.ownVehicle || 
                            this.formGroup.value.businessOwnVehicleAtEndOfLease === 'Y' || 
                            this.formGroup.value.businessOwnVehicleAtEndOfLease === 'N' ">
                    <div class="row mt-10">          
                    <div class="col-md-12">        
                        <p class="bold my-1 mt-20"><span class="label"> What is the make, model and year of the business's vehicle(s)?
                        </span>
                        </p>
                    </div>     
                    </div>  
                
                    <div *ngFor="let c of this.otherCoreBusinessActivitiesFunctions.listModelYearDetails;" id="listModelYearDetailsSection">
                    <div class="row mt-10" *ngIf="c.id <= this.otherCoreBusinessActivitiesFunctions.numberOfModel" >
                        <div>
                            <div class="row">                            
                                <div class="col-12  col-md-4">
                                    <app-text-field label='Make and model'  
                                        propertyName="{{c.model}}"
                                        [FIELD_SPACING]="10"
                                        [columns]="12"
                                        [regular]="regular"
                                        [formGroup]="this.formGroup"
                                        [tooltip]="modelTooltipMessage">
                                    </app-text-field>
                                </div>  
                                
                                <div class="col-12  col-md-4">
                                    <app-number-field
                                        label='Year'
                                        propertyName="{{c.year}}"
                                        [FIELD_SPACING]="10"
                                        [columns]="12"
                                        [regular]="regular"
                                        [formGroup]="this.formGroup"
                                        [LABEL_SPACING]="0"
                                        [maxLength]=4>
                                    </app-number-field>
                                </div> 
                                <div class="col-12 col-md-2" *ngIf="c.id > 1 && c.id == this.otherCoreBusinessActivitiesFunctions.numberOfModel">          
                                    <div class="col-md-12 remove-model-btn" >
                                        <a id="removeModelAndYearLink"  (click)="removeModelAndYear(c.id)" href="javascript:void(0)">Remove</a>
                                    </div>
                                </div> 
                                
                            </div>
                        </div>  
                        
                    </div>       
                    </div>
                    
                    <div class="row" >
                        <div class="col-md-12"> 
                            <a id="addModelAndYearLink" *ngIf="this.otherCoreBusinessActivitiesFunctions.numberOfModel < this.otherCoreBusinessActivitiesFunctions.listModelYearDetails.length" (click)="addNewModelOrYear()" href="javascript:void(0)" >Add another vehicle</a>   
                        </div>
                    </div>
                </div>

            
            </div>             

        </div>
    </div>  
</div>